import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import Popover from '../../../../base/popover/components/Popover.web';
import { SMALL_MOBILE_WIDTH } from '../../../../base/responsive-ui/constants';
import { getModeratorSettingsVisibility } from '../../../functions.web';
import ModeratorSettingsContent from './ModeratorSettingsContent';
import { toggleModeratorSettings } from "../../../actions.web";
import { getLocalParticipant, isParticipantModerator } from "../../../../base/participants/functions";
import UserSettings from "../user/UserSettings";
import { getWindowQueryData } from "../../../../desktop-picker/functions";
const useStyles = makeStyles()(() => {
    return {
        container: {
            display: 'inline-block'
        }
    };
});
/**
 * Popup with moderator settings.
 *
 * @returns {ReactElement}
 */
function ModeratorSettingsPopup({ children, isOpen, onClose, popupPlacement, isModerator, }) {
    const { classes, cx } = useStyles();
    const { isSupportPreJoinPage } = getWindowQueryData();
    const content = () => {
        if (isSupportPreJoinPage) {
            return isModerator ? React.createElement(ModeratorSettingsContent, null) : React.createElement(UserSettings, null);
        }
        return React.createElement(ModeratorSettingsContent, null);
    };
    return (React.createElement("div", { className: classes.container },
        React.createElement(Popover, { allowClick: true, content: content(), headingId: 'moderator-settings-button', onPopoverClose: onClose, position: popupPlacement, trigger: 'click', visible: isOpen }, children)));
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { clientWidth } = state['features/base/responsive-ui'];
    const localParticipant = getLocalParticipant(state);
    const isModerator = isParticipantModerator(localParticipant);
    return {
        popupPlacement: clientWidth <= Number(SMALL_MOBILE_WIDTH) ? 'auto' : 'top-mid',
        isOpen: Boolean(getModeratorSettingsVisibility(state)),
        isModerator,
    };
}
const mapDispatchToProps = {
    onClose: toggleModeratorSettings,
};
export default connect(mapStateToProps, mapDispatchToProps)(ModeratorSettingsPopup);
